import React from 'react';
import { TextField, Icon, Typography } from '@scale/scaleui';

interface TemplateVariablesListProps {
  templateVariables: string[];
  variableValues: Record<string, string>;
  setVariableValues: (val: Record<string, string>) => void;
}

const TemplateVariablesList = ({
  templateVariables,
  variableValues,
  setVariableValues,
}: TemplateVariablesListProps) => {
  const onVariableChange = (variable: string, newVal: string) => {
    const newVariableValues = { ...variableValues, [variable]: newVal };
    setVariableValues(newVariableValues);
  };

  return (
    <div className="flex flex-col flex-grow gap-2">
      <div className="flex items-center gap-2">
        <Icon icon={['fas', 'info-circle']} size="sm" variant="neutral" />
        <Typography.Paragraph3>
          The values for template variables will be the same for every email sent.
        </Typography.Paragraph3>
      </div>
      {templateVariables.map(variable => (
        <TextField
          label={variable}
          key={`template-variable-${variable}`}
          value={variableValues[variable]}
          onChange={e => onVariableChange(variable, e.target.value)}
        />
      ))}
    </div>
  );
};

export default TemplateVariablesList;
